import LabelUtil from 'bpmn-js/lib/util/LabelUtil';

LabelUtil.hasExternalLabel = (semantic) => semantic.$type !== 'bpmn:Process';
